import React  from 'react'
import DropDown from '../dropdown';
import { GetReservationStatuses } from '../../../api/services/pms';

const ReservationStatusesDropDown = ({...props}) => {
    return <DropDown search={false} api={GetReservationStatuses} textField="Name" valueField="Id"  {...props}/>
}

export default ReservationStatusesDropDown